module.exports = __webpack_public_path__ + "img/avatar-42.767999dc.png";